export default __webpack_public_path__ + "static/media/bg_main_careers.07035a9c.png";